export default {
    setBartolomeConfig(state,bart){
        state.bartolome_config = bart
    },
    setMewoConfig(state,mewo){
        state.mewo_config = mewo;
    },
    setActivo(state,bool){
        state.activo = bool;
    },
    setPago(state,pagos){
        state.pago = pagos
    },
    setServicio(state,formas){
        state.servicio = formas
    },
    setTotem(state,t){
        state.totemObj = t
    },
    setModoFuncionamiento(state,val){
        state.modoFuncionamiento = val
    }
}